var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShouhuozhong = function SvgShouhuozhong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "shouhuozhong_svg__a",
    d: "M0 0h26v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shouhuozhong_svg__c",
    d: "M0 20h26V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shouhuozhong_svg__d",
    d: "M0 20h26V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "shouhuozhong_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#shouhuozhong_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1.5v17h22.997l.003-17h-23ZM24 18.18v.909-.909ZM24 20H2c-1.103 0-2-.816-2-1.819V1.818C0 .815.897 0 2 0h22c1.103 0 2 .815 2 1.818v16.363C26 19.184 25.103 20 24 20Z",
    fill: "#333",
    mask: "url(#shouhuozhong_svg__b)"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#333",
    y: 12,
    width: 8,
    height: 1.5,
    rx: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#333",
    x: 18,
    y: 12,
    width: 8,
    height: 1.5,
    rx: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.998 10c.405 0 .734.329.734.734v6.704l2.015-2.06a.725.725 0 0 1 1.038 0c.291.298.291.764.006 1.056l-3.12 3.187a.726.726 0 0 1-.07.063.734.734 0 0 1-1.212-.009.522.522 0 0 1-.05-.043l-.01-.01-3.12-3.188a.75.75 0 0 1 0-1.05l.006-.005a.726.726 0 0 1 1.038 0l2.01 2.054.001-6.7c0-.404.329-.733.734-.733Z",
    fill: "#333"
  }))));
};

export default SvgShouhuozhong;